import React from "react";
import {
  Heading,
  Box,
  Link,
  Text,
  VStack,
  HStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { FaSmileBeam } from "react-icons/fa";
import { FaFaceSadCry } from "react-icons/fa6";
import Reveal from "./base/Reveal";
import { accent, muted, border as borderColor } from "../constants/constants";

const enjoys = [
  "Legos",
  "Building PCs and Keyboards",
  "Kayaking",
  "Go Karting",
];
const notForMe = ["Skiing and Ice Skating", "Pottery", "Crochet"];

const About: React.FC = () => {
  return (
    <Box
      as="section"
      id="about"
      aria-labelledby="about-heading"
      bg="brand.bg"
      minHeight="100vh"
      py={{ base: 20, md: 28 }}
      px={{ base: 6, md: 20 }}
      scrollMarginTop={{ base: "70px", md: "90px" }}
    >
      <Box maxWidth="700px" mx="auto" textAlign="center">
        <Reveal>
          <Heading
            id="about-heading"
            fontSize={{ base: "4xl", md: "6xl" }}
            fontWeight={900}
            color="brand.text"
            mb={8}
          >
            Hey,{" "}
            <Box as="span" color={accent}>
              I&apos;m Aman.
            </Box>
          </Heading>
        </Reveal>

        <Reveal delay={0.1}>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="brand.muted"
            mb={4}
            lineHeight="1.7"
          >
            I am a Senior Software Engineer with a passion for learning new
            things, be it code or not, and exploring the unknown. In my free
            time, you&apos;ll find me diving into{" "}
            <Link
              href="https://www.suckerpunch.com/category/games/ghostoftsushima/"
              color={accent}
              isExternal
            >
              video games
            </Link>
            , experimenting with{" "}
            <Link
              href="https://www.jambojamborestaurant.com.au/"
              color={accent}
              isExternal
            >
              new cuisines
            </Link>
            , or on the court playing{" "}
            <Link
              href="https://bwfbadminton.com/player/89916/praveen-jordan"
              color={accent}
              isExternal
            >
              badminton
            </Link>
            .
          </Text>
        </Reveal>

        <Reveal delay={0.2}>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="brand.muted"
            mb={10}
            lineHeight="1.7"
          >
            When I get some free time, I love to take on hobbies to varying
            degrees of success. Here&apos;s a list of things I&apos;ve found
            myself a fan of, and some that I haven&apos;t.
          </Text>
        </Reveal>

        <VStack spacing={6}>
          <Reveal delay={0.3} width="100%">
            <Box>
              <Text fontSize="sm" fontWeight={700} color="brand.text" mb={3}>
                Enjoy
              </Text>
              <Wrap spacing={3} justify="center">
                {enjoys.map((item) => (
                  <WrapItem key={item}>
                    <HStack
                      spacing={2}
                      px={4}
                      py={2}
                      borderRadius="full"
                      border="1px solid"
                      borderColor="brand.accentMuted"
                      bg="brand.accentMuted"
                      transition="transform 0.2s ease, border-color 0.2s ease"
                      _hover={{
                        transform: "translateY(-3px)",
                        borderColor: accent,
                      }}
                    >
                      <Box
                        as={FaSmileBeam}
                        aria-hidden="true"
                        color={accent}
                        boxSize={3.5}
                      />
                      <Text fontSize="sm" fontWeight={600} color="brand.text">
                        {item}
                      </Text>
                    </HStack>
                  </WrapItem>
                ))}
              </Wrap>
            </Box>
          </Reveal>

          <Reveal delay={0.4} width="100%">
            <Box>
              <Text fontSize="sm" fontWeight={700} color="brand.text" mb={3}>
                Not for me
              </Text>
              <Wrap spacing={3} justify="center">
                {notForMe.map((item) => (
                  <WrapItem key={item}>
                    <HStack
                      spacing={2}
                      px={4}
                      py={2}
                      borderRadius="full"
                      border="1px dashed"
                      borderColor={borderColor}
                      transition="transform 0.2s ease, border-color 0.2s ease"
                      _hover={{
                        transform: "translateY(-3px)",
                        borderColor: muted,
                      }}
                    >
                      <Box
                        as={FaFaceSadCry}
                        aria-hidden="true"
                        color={muted}
                        boxSize={3.5}
                      />
                      <Text fontSize="sm" fontWeight={600} color="brand.muted">
                        {item}
                      </Text>
                    </HStack>
                  </WrapItem>
                ))}
              </Wrap>
            </Box>
          </Reveal>
        </VStack>
      </Box>
    </Box>
  );
};

export default About;
